<template>
    <div class="page_body">
        <div class="data_main">
            <div class="data_search" v-if="power.indexOf('1')>=0">
                <el-form ref="listQuery" :inline="true" :model="listQuery" size="small" label-width="72px">
                    <el-form-item label="关键词：" prop="key">
                        <el-input v-model="listQuery.key" placeholder="请输入关键词" @keyup.enter.native="toSearchList"></el-input>
                    </el-form-item>
                    <el-form-item class="last">
                        <el-button type="primary" :loading="isSearchLoading" @click="toSearchList()">查 询</el-button>
                        <el-button @click="$refs['listQuery'].resetFields()">重 置</el-button>
                    </el-form-item>
                </el-form>
            </div>

            <div class="data_group" :class="power.indexOf('1')>=0?'mt18':''">
                <el-button type="primary" size="small" icon="el-icon-plus" @click="$router.push('/faq/add')" v-if="power.indexOf('2')>=0">添加常见问题</el-button>
            </div>

            <div class="data_table mt18">
                <el-table :data="listData" style="width: 100%" v-loading="isRequestLoading">
                    <el-table-column prop="sort" label="排序" min-width="60" align="center"></el-table-column>
                    <el-table-column prop="question" label="问题" min-width="200px" align="center">
                        <template slot-scope="scope">
                          <div class="hidden">{{scope.row.question}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="回答" min-width="150" align="center">
                      <template slot-scope="scope">
                        <div class="hidden" v-html="scope.row.answer"></div>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center" min-width="100" v-if="power.indexOf('3')>=0">
                      <template slot-scope="scope">
                        <el-button type="text" @click="delData(scope.row.id)">删除</el-button>
                      </template>
                    </el-table-column>
                </el-table>
            </div>

            <pagination :size="listQuery.pageSize" :total="pages.total" :current="listQuery.page" :pages="pages.pages" @pageChange="pageChange"/>
        </div>
    </div>
</template>

<script>
import pagination from '@/components/pagination'
import {mapState} from "vuex";
import {getFaq,delFaq} from "@/api";
export default {
  name: "contentArticleIndex",
  data () {
    return {
      listQuery: {
        key: '',
        sortType: '',
        page: 1,
        pageSize: 10
      },
      pages: {
        total: 0,
        pages: 0
      },
      isShow:false,
      isSearchLoading: false,
      isRequestLoading: false,
      listData: [],
      power:null
    }
  },
  computed: {
    ...mapState({
      listKeepAlive: state => state.app.listKeepAlive,
    })
  },
  activated () {
    this.getFaq()
  },
  created(){
    this.power = JSON.parse(localStorage.getItem('userRole')).power[6]
  },
  methods: {
    getFaq () {
      this.isRequestLoading = true
      getFaq(this.listQuery).then(res => {
        this.isRequestLoading = false
        this.isSearchLoading = false
        if (res.code === 0) {
          this.isShow = true
          this.listData = res.data.records
          this.pages.total = res.data.total
          this.pages.pages = res.data.pages
        }
      }).catch(() => {
        this.isRequestLoading = false
        this.isSearchLoading = false
      })
    },
    pageChange (e) {
      this.listQuery.page = e.current
      this.listQuery.pageSize = e.size
      this.getFaq()
    },
    toSearchList () {
      this.listQuery.page = 1
      this.isSearchLoading = true
      this.getFaq()
    },
    toEditArticle (id) {
      this.$router.push({path: '/content/article/edit', query: {id: id}})
    },
    delData (id) {
      this.$confirm('此操作将永久删除该文章, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        delFaq(id).then(res => {
          if (res.code === 0) {
            this.$message({
              message: '文章删除成功',
              type: 'success',
              showClose: true,
            });
            this.getFaq()
          }
        })
      }).catch(() => {});
    }
  },
  components: {
    pagination
  }
}
</script>
<style lang="scss" scoped>
.hidden{
    overflow : hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
}
</style>